import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import Axios from 'axios';
import Moment from 'moment';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from '.';

export const CacheGrid = forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [actionFormInit, setPageFormInit] = useState(null);

    const fetchData = async () => {
        try {
            let dataResponse = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/caches`);
            return dataResponse.data;
        } catch (err) {
            console.log(err);
        }
    }

    const init = async () => {
        setLoading(true);
        let d = await fetchData();
        setData(d);
        setLoading(false);
    }

    const onFormSuccess = async (values) => {
        try {
            if (values.id) {
                let id = values.id;
                delete values.id;
                await Axios.patch(`${process.env.REACT_APP_API_BASE_URI}/api/caches/${id}`, values);
            } else {
                await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/caches`, values);
            }
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    const onDeleteItem = async (id) => {
        try {
            await Axios.delete(`${process.env.REACT_APP_API_BASE_URI}/api/caches/${id}`);
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        init();
    }, []);

    useImperativeHandle(ref, () => ({
        init: init,
        setPageFormInit: setPageFormInit,
    }));

    return (
        <>
            {props.showActions
                ? <Antd.Space
                    style={{
                        marginBottom: 10,
                        float: 'right',
                    }}
                >
                    <Antd.Button
                        icon={<AntdIcons.ReloadOutlined />}
                        title="Reload"
                        disabled={loading}
                        onClick={() => {
                            init();
                        }}
                    />
                    <Antd.Button
                        icon={<AntdIcons.PlusOutlined />}
                        title="Create new"
                        disabled={loading}
                        onClick={() => {
                            setPageFormInit({});
                        }}
                    />
                </Antd.Space>
                : null}
            <Antd.Table
                size={'small'}
                loading={loading}
                dataSource={data}
                rowKey={'id'}
            >
                <Antd.Table.Column
                    key='connector'
                    dataIndex='connector'
                    title='Connector'                    
                />
                <Antd.Table.Column
                    key='dataset'
                    dataIndex='dataset'
                    title='Dataset'                    
                />
                <Antd.Table.Column
                    key='staleTime'
                    dataIndex='staleTime'
                    title='Stale time [min]'                    
                />
                <Antd.Table.Column
                    key='client'
                    dataIndex='client'
                    title='Client'
                    width={100}
                    render={val => (
                        <Antd.Tag
                            color={val === true ? 'green' : 'volcano'}
                            key={val}
                        >
                            {val === true ? 'YES' : 'NO'}
                        </Antd.Tag>
                    )}
                />
                <Antd.Table.Column
                    key='server'
                    dataIndex='server'
                    title='Server'
                    width={100}
                    render={val => (
                        <Antd.Tag
                            color={val === true ? 'green' : 'volcano'}
                            key={val}
                        >
                            {val === true ? 'YES' : 'NO'}
                        </Antd.Tag>
                    )}
                />
                <Antd.Table.Column
                    key='action'
                    title='Action'
                    width={100}
                    render={(value, record) => (
                        <Antd.Space
                            size="middle"
                        >
                            <a
                                onClick={() => {
                                    setPageFormInit(record);
                                }}
                            >
                                Edit
                            </a>
                            <Antd.Popconfirm
                                placement="topLeft"
                                title="Do you really want to delete the entry?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    onDeleteItem(record.id);
                                }}
                            >
                                <a>
                                    Delete
                                </a>
                            </Antd.Popconfirm>
                        </Antd.Space>
                    )}
                />
            </Antd.Table>
            <Antd.Drawer
                title={actionFormInit && actionFormInit.id
                    ? 'Edit cache'
                    : 'Create new cache'}
                width={1200}
                visible={actionFormInit !== null
                    ? true
                    : false}
                closable={true}
                onClose={() => setPageFormInit(null)}
            >
                {actionFormInit
                    ? <SYS.CacheForm
                        initialValues={actionFormInit}
                        onSuccess={onFormSuccess}
                    />
                    : null}
            </Antd.Drawer>
        </>
    )
})